// extracted by mini-css-extract-plugin
module.exports = {"daysContainer":"Days_daysContainer__JLNoK","days":"Days_days__koGFh","day":"Days_day__1eUTf","clickedDay":"Days_clickedDay__34k-o","droppable":"Days_droppable__25Zez"};